<template>
	<div>
        <v-tabs 
            class="round-card"
            height="34"
            background-color="background-1"
            slider-color="primary">
            <v-tab key="Campi" ripple class="secondary-tab">
                Campi
            </v-tab>
            <v-tab key="Azioni" ripple class="secondary-tab">
                Azioni
            </v-tab>
            <v-tab key="Template" ripple class="secondary-tab">
                Template
            </v-tab>

            <v-tab-item class="pb-offset background-1 pb-1" key="Campi">
                <v-row class="ma-0">
                    <v-col class="pa-0 pt-2" cols="12">
                        <fields-selector model-def="purchaseorder"></fields-selector>
                    </v-col>
                </v-row>
                <v-row class="ma-0 pb-offset">
					<v-col class="pa-0 pt-2" cols="12">
						<fields-selector model-def="productpurchaseorder" audit></fields-selector>
					</v-col>
				</v-row>
            </v-tab-item>
            
            <v-tab-item class="pb-offset background-1 pb-1" key="Azioni">
                <v-row class="ma-0">
                    
                    <v-col class="pa-0 pt-2" cols="12">
                        <actions-selector model-def="purchaseorder"></actions-selector>
                    </v-col>

                </v-row>
            </v-tab-item>
            
            <v-tab-item class="pb-offset background-1 pb-1" key="Template">
                <v-row class="ma-0">
                    <v-col class="pa-0 pt-4" cols="12">
                        <crud
                            model-def="templates-purchaseorder"
                            action-icon="dynamic_feed"
                            title="Template Ordini di acquisto"
                            action-position='absolute'>
                        </crud>
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs>

    </div>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'

	export default {
		name:'orders-settings',
        components: {
			FieldsSelector,
			ActionsSelector,
        },		
		data() {
			return {

			}
		},
	}
  </script>
